var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600px" },
      model: {
        value: _vm.nameChangeDialog,
        callback: function ($$v) {
          _vm.nameChangeDialog = $$v
        },
        expression: "nameChangeDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("changeName")) + " "),
                _c(
                  "button",
                  {
                    attrs: { id: "dialog_exit" },
                    on: {
                      click: function ($event) {
                        _vm.nameChangeDialog = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/popup_close.png"),
                        id: "btn_img",
                      },
                    }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _vm.isMobile == false
                      ? _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 pt-7 pb-10 dialog_text",
                                attrs: { align: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.t("changeName")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pl-3",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newName,
                                          expression: "newName",
                                        },
                                      ],
                                      staticClass: "change_name_input",
                                      domProps: { value: _vm.newName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.newName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 pb-2",
                                attrs: { align: "center", justify: "center" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "grey_btn",
                                      width: "8rem",
                                      height: "2rem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.nameChangeDialog = false
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("back")))]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      id: "blue_btn",
                                      width: "8rem",
                                      height: "2rem",
                                      loading: _vm.updateLoading,
                                    },
                                    on: { click: _vm.updateName },
                                  },
                                  [_vm._v(_vm._s(_vm.t("change")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "11" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pt-7 pb-10 dialog_text",
                                attrs: { align: "left" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pb-1",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.t("changeName")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newName,
                                          expression: "newName",
                                        },
                                      ],
                                      staticClass: "change_name_input",
                                      staticStyle: { width: "100%" },
                                      domProps: { value: _vm.newName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.newName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 pb-2",
                                attrs: { align: "center", justify: "center" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "grey_btn",
                                      width: "6rem",
                                      height: "2rem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.nameChangeDialog = false
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("back")))]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      id: "blue_btn",
                                      width: "6rem",
                                      height: "2rem",
                                      loading: _vm.updateLoading,
                                    },
                                    on: { click: _vm.updateName },
                                  },
                                  [_vm._v(_vm._s(_vm.t("change")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }